<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--sm">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon" style="color:rgb(var(--danger));background:#fee2e2;"><i class="ri-error-warning-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">MISE A JOUR</h4>
                                <p class="cf-modal-head__sub">Opération sensible</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-body">

                    <div class="box-body">


                        <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                            <div v-html="messagesucces">

                            </div>
                        </div>

                        <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">


                                <div v-html="messageerror">

                                </div>

                        </div>



                        <strong>
                            {{titlemodal}}
                        </strong>
                        <br>
                        <br>
                        <h1>⚠️ AVERTISSEMENT IMPORTANT ⚠️</h1>
                        <p>
                            L'opération d'éclatement de caisse est <strong>irréversible</strong>.
                            Elle couvre l'ensemble des opérations <strong>du début de l'opération référentielle</strong> jusqu'à <strong>la fin de toutes les opérations</strong>.
                        </p>
                        <p>
                            Si des journées clôturées sont enregistrées après cette journée, <strong>cela impactera également ces opérations</strong>.
                        </p>
                        <p>
                            Veuillez confirmer uniquement si vous êtes sûr de vouloir procéder.
                            <strong>Si vous ne comprenez pas cette opération, veuillez vous rapprocher de votre administrateur.</strong>
                        </p>
                        <br>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="xl:col-span-1 col-span-1">
                                <input class="form-check-input me-2" type="checkbox" v-model="checkok">
                            </div>

                            <div class="xl:col-span-10 col-span-10">

                                <p class="mb-0 text-muted" style="color: red;font-weight: bolder">Cochez pour confirmer que vous comprenez les risques.</p>

                            </div>


                        </div>

                    </div>




                </div>
                <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Non</button>
                        <button :disabled="!checkok" @click="btnsuppression" type="button" class="ti-btn ti-btn-danger-full disabled:opacity-60"><i class="ri-check-line align-middle"></i> Oui</button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>



</template>

<script>

    //import allfunction from "@/allfunction";
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",
        watch: {


        },

        computed:{




        },
        components: {


        },

        data() {
            return {
                isdisplay:false,
                datavalue:"",
                titlemodal:"",
                Items:{},
                typedoc:"",
                checkok:false,
                typededocument:"",
                messageerror:"",
                messagesucces:"",
            };
        },
        methods: {

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },


            show(titlemodal,Items){
                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal
                this.Items=Items
                this.checkok=false
                           this.isdisplay=true;

            },

            async  btnsuppression(){

                if (this.checkok===false){return }

                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/utilitaire/maj/'+this.$store.state.appsociete+'/eclatementoperationsurunedate/'+randomString();
                let response =   axios  .post(url,this.Items,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");


                            t.close()

                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");
                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b>Erreur</b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))


            },








        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--sm { max-width:460px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
@media (max-width:768px) { .cf-dialog--sm { max-width:100%; } }
</style>